import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-unauthorized',
    standalone: true,
    imports: [TranslatePipe],
    templateUrl: './unauthorized.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnauthorizedComponent {}
